import React ,{ useEffect, useState } from "react";
import { Checkbox, Row, Col, Select, Button, message, Switch,Modal } from "antd";
import { CheckOutlined, CloseOutlined,ExclamationCircleFilled } from "@ant-design/icons";
import "./exportTemplate.scss";
import DraggableGrid from "../draggable";
import useExportTemplateStore from "../../store/exportTemplate.store";
import ExportModal from "../exportModal";
import useResumeStore from "../../store/resume.store";
import { DownloadOutlined, DeleteOutlined } from "@ant-design/icons";
import { all } from "axios";
const { confirm } = Modal;

function ExportTemplate() {
  const {
    exportTemplateArray,
    getAllExportTemplate,
    createExportTemplate,
    allExportTemplates,
    deleteExportTemplate,
    setCurrentExportTemplateArray,
    updateExportTemplate,
    getTemplateData,
    templateData,
    currentExportTemplateArray,
    downloadTemplateExcel,
  } = useExportTemplateStore();
  const {handleDownloadAll } = useResumeStore();
  //console.log("template data in comp", templateData);
  const [isEmpty, setIsEmpty] = useState(true);
  const [currentTemplateID, setCurrentTemplateID] = useState();
  const [templateName, setTemplateName] = useState("");
  const [selectedValues, setSelectedValues] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();
  const [pivotLayoutOn, setPivotLayoutOn] = useState(false);
  const [showFields, setShowFields] = useState(false);

  useEffect(() => {
    const fetch = async () => {
      const templates = await getAllExportTemplate();
      const selectedExportTemplate = localStorage.getItem(
        "selectedExportTemplateID"
      );
      //console.log("these are my templates", templates);
      if (selectedExportTemplate) {
        const currentTemplate = templates?.filter(
          (t) => t.templateid == selectedExportTemplate
        );
        if (currentTemplate?.length > 0) {
          setTemplateName(currentTemplate[0].templatename);
          setCurrentTemplateID(currentTemplate[0].templateid);
          const newFields = currentTemplate[0]?.fields?.filter(
            (ele) => ele !== "" && ele !== "TRACKER_HEADING_END"
          );
          setSelectedValues(newFields);
          setCurrentExportTemplateArray(newFields);
        }
      }
    };
    fetch();
  }, [getAllExportTemplate]);

  useEffect(() => {
    getTemplateData();

    if (!localStorage.getItem("pivotLayout")) {
      localStorage.setItem("pivotLayout", false);
    } else {
      localStorage.getItem("pivotLayout") === "true"
        ? setPivotLayoutOn(true)
        : setPivotLayoutOn(false);
    }
  }, []);

  useEffect(() => {
    if (allExportTemplates?.length > 0) {
      setIsEmpty(false);
    }
  }, [allExportTemplates]);

  const success = () => {
    messageApi.open({
      type: "success",
      content: "Template Updated Successfully",
    });
  };

  const onChange = (checkedValues) => {
    //console.log("checked = ", checkedValues);
    setSelectedValues((prev) => [...prev, ...checkedValues]);
  };

  const handleRemove = (valueToRemove) => {
    setSelectedValues((prev) => prev.filter((item) => item !== valueToRemove));
  };

  const createTemplate = async (
    modalTemplateName,
    setOpenResponsive,
    modalSelectedValues
  ) => {
    const body = {
      UpdateType: "TEMPLATE_ADD",
      TemplateList: [
        {
          ClientName: "Accenture",
          TAName: "Pooja",
          TemplateName: modalTemplateName,
          Fields: [...modalSelectedValues, "TRACKER_HEADING_END"],
        },
      ],
    };
    const response = await createExportTemplate(body);
    setCurrentTemplateID(response[modalTemplateName]);
    setOpenResponsive(false);
    setSelectedValues(body.TemplateList[0].Fields);
    setTemplateName(body.TemplateList[0].TemplateName);
    setIsEmpty(false);
    setCurrentExportTemplateArray(modalSelectedValues);

    localStorage.setItem(
      "selectedExportTemplateID",
      response[modalTemplateName]
    );
  };

  const updateTemplate = async () => {
    const body = {
      UpdateType: "TEMPLATE_MODIFY",
      TemplateList: [
        {
          ClientName: "Accenture",
          TAName: "Pooja",
          TemplateName: templateName,
          TemplateId: currentTemplateID,
          Fields: [...selectedValues, "TRACKER_HEADING_END"],
        },
      ],
    };
    await updateExportTemplate(body);
    setSelectedValues(body.TemplateList[0].Fields);
    setCurrentExportTemplateArray(selectedValues);
    success();
    setShowFields(false);
  };

  const deleteTemplate = async () => {
    if (allExportTemplates?.length === 1) {
      setIsEmpty(true);
    }
    await deleteExportTemplate(currentTemplateID);
    await getAllExportTemplate();

    const currentTemplates =
      useExportTemplateStore.getState().allExportTemplates;

    handleInputChange(currentTemplates[0]?.templatename);
    setShowFields(false);
  };

  const handleInputChange = (value) => {
    const specificTemplate = allExportTemplates?.filter(
      (template) => template.templatename === value
    );
    setTemplateName(specificTemplate[0]?.templatename);
    setCurrentTemplateID(specificTemplate[0]?.templateid);
    const newFields = specificTemplate[0]?.fields?.filter(
      (ele) => ele !== "" && ele !== "TRACKER_HEADING_END"
    );
    setSelectedValues(newFields);
    setCurrentExportTemplateArray(newFields);
    localStorage.setItem(
      "selectedExportTemplateID",
      specificTemplate[0]?.templateid
    );
  };
  const exportTemplateCSV = () => {
    downloadTemplateExcel(selectedValues);
  };

  const normalize = (arr) =>
    (arr || [])?.filter((el) => el !== "" && el !== "TRACKER_HEADING_END");

  const arraysEqual = (a = [], b = []) => {
    if (a?.length !== b?.length) return false;
    for (let i = 0; i < a?.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  };

  const isChanged = !arraysEqual(
    normalize(selectedValues),
    normalize(currentExportTemplateArray)
  );

  const showDeleteConfirm = () => {
    confirm({
      title: "Are you sure you want to delete this template?",
      icon: <ExclamationCircleFilled />,

      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        deleteTemplate();
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const handleReorder = (newOrder) => {
    setSelectedValues(newOrder);
  };

  return (
    <>
      <div className="exportTemplate-wrapper">
        <h1 className="exportTemplate-title-heading">Templates</h1>
        <div className="exportTemplate-sub-title">
          <div className="exportTemplate-sub-title-left">
            <span className="sub-title-text">Selected Template: </span>
            <Select
              style={{
                width: 200,
              }}
              placeholder="None"
              onChange={handleInputChange}
              value={templateName || undefined}
              options={allExportTemplates?.map((template) => {
                return {
                  value: template?.templatename,
                  label: template?.templatename,
                };
              })}
            />
            <Checkbox
              className="edit-checkbox"
              onChange={() => setShowFields((prev) => !prev)}
              checked={showFields}
            >
              Edit
            </Checkbox>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "right",
              alignItems: "center",
              gap: 12,
            }}
          >
            <ExportModal createTemplate={createTemplate} />
            <Button onClick={exportTemplateCSV}>
              <DownloadOutlined />
              Download Import Template File
            </Button>
          </div>
        </div>

        {isEmpty ? (
          <></>
        ) : (
          <>
            <div className="company-select">
              <div className="company-select-left"></div>
            </div>

            <div className="checkbox-group-wrapper">
              <div className="checkbox-group-title-wrapper">
                <div className="checkbox-group-title">
                  <div className="template-column-title">
                    Selected Template Columns{" "}
                    {showFields && "(Drag to Reorder)"}
                  </div>
                  <Switch
                    size="small"
                    checked={pivotLayoutOn}
                    onChange={(checked) => {
                      if (checked) {
                        setPivotLayoutOn(true);
                        localStorage.setItem("pivotLayout", true);
                      } else {
                        setPivotLayoutOn(false);
                        localStorage.setItem("pivotLayout", false);
                      }
                    }}
                  />
                  <p className="pivot-text">Pivot Layout</p>
                </div>

                <div className="pivot-switch-wrapper">
                  <Button onClick={showDeleteConfirm}>
                    <DeleteOutlined />
                    Delete
                  </Button>
                </div>
              </div>
              <div className="checkbox-group-wrapper">
                <DraggableGrid
                  items={(selectedValues || []).filter(
                    (val) => val !== "" && val !== "TRACKER_HEADING_END",
                  )}
                  onReorder={handleReorder}
                  onRemove={handleRemove}
                  editMode={showFields}
                />
              </div>
              {showFields && (
                <>
                  <div className="template-select-column-title">
                    Select Template Columns
                  </div>
                  <Checkbox.Group
                    style={{ width: "100%" }}
                    defaultValue={exportTemplateArray}
                    value={selectedValues}
                    onChange={onChange}
                  >
                    <Row gutter={[16, 16]}>
                      {templateData
                        .slice()
                        .filter((option) => !selectedValues.includes(option))
                        .map((option) => (
                          <Col span={6} key={option}>
                            <Checkbox
                              value={option}
                              checked={selectedValues.includes(option)}
                            >
                              {option}
                            </Checkbox>
                            {selectedValues.includes(option) && (
                              <span
                                style={{
                                  marginLeft: "10px",
                                  fontWeight: "bold",
                                }}
                              >
                                ({selectedValues.indexOf(option) + 1})
                              </span>
                            )}
                          </Col>
                        ))}
                    </Row>
                  </Checkbox.Group>

                  <div className="btn-wrapper">
                    {contextHolder}
                    <Button onClick={updateTemplate} disabled={!isChanged}>
                      Save
                    </Button>
                  </div>
                </>
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default ExportTemplate;
